<template>
  <OfferWallComponent></OfferWallComponent>
</template>

<script>
import OfferWallComponent from './components/OfferWallComponent.vue';
export default {
  name: 'App',
  components: {
    OfferWallComponent
  },
  data: function(){
    return{
    }
  },
}
</script>

<style lang="scss" scoped>
body {
  margin: 0;
  padding: 0;
}
</style>
